var _path, _path2, _path3, _path4, _path5, _rect, _path6, _rect2, _rect3, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 120,
    viewBox: "0 0 132 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 60C131.5 93.1371 76.6371 120 43.5 120C10.3629 120 0 93.1371 0 60C0 26.8629 10.3629 0 43.5 0C76.6371 0 131.5 26.8629 131.5 60Z",
    fill: "#F4F6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 44.5L72.5 60.5L95 84V36L87.5 44.5Z",
    fill: "#34A7F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 44.5L50.5 60.5L28 84V36L35.5 44.5Z",
    fill: "#34A7F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95 84H28L50 61L57.0284 67.7746C59.5003 70.3096 63.5054 70.3096 65.9783 67.7746L73 61L95 84Z",
    fill: "#42B2F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95 36H28L61.5 74L95 36Z",
    fill: "#3397D7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F4F6F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63 59.1363L65.654 61.9111C65.8451 62.1108 65.8378 62.4276 65.638 62.6184L60.8452 67.1932C60.5271 67.4969 60 67.2714 60 66.8315V57.2461C60 56.7952 60.5497 56.5747 60.8613 56.9005L63 59.1363Z",
    fill: "#34A7F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 25,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#EEECEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 25,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#47B78E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 37.5L88.875 41.25L95.125 35",
    stroke: "#F4F6F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.3a725f902ff69cb65eae3e82119a4bea.svg";
export { ForwardRef as ReactComponent };